import {HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class CatalogResultGroupService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';
        req.catalog_id = req.catalog_id  || '';


        let requestUrl = environment.apiUrl + 'catalog/result/group/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter + "&catalog_id=" + req.catalog_id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(category){
        let requestUrl = environment.apiUrl + 'catalog/result/group/store';
        return this.http.post(requestUrl, category).map( (res: any) => {
            return res;
        });
    }

    edit(category){
        let requestUrl = environment.apiUrl + 'catalog/result/group/update/' + category.id;
        return this.http.put(requestUrl, category).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'catalog/result/group/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id){
        let requestUrl = environment.apiUrl + 'catalog/result/group/delete/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    updateOrder(req){
        let requestUrl = environment.apiUrl + 'catalog/result/group/updateOrder';
        return this.http.post(requestUrl, req).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/catalog.result.group.service.ts